import { Component, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { CheckListDTO, ImageDTO, SafeVideoDTO, TemplateDTO, UserProcedureDataDTO, VideoDTO, DeleteImageDTO, DeleteCheckListDTO, DeleteVideoDTO } from '../Models/Procedure.model';
import { Globals } from '../Models/UserProfile.model';
import { AppWideUser, Token } from '../Services/AppUserProfile';
import { SrubUpService } from '../Services/ScrubUp.service';
import { UserProcedureComponent } from '../user-procedure/user-procedure.component';
import { ProcedureComponent } from '../procedure/procedure.component';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { element } from 'protractor';
import { Alert, AlertPromise } from 'selenium-webdriver';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { AnimateTimings } from '@angular/animations';
declare var $: any;
declare var swal: any;
interface FileReaderEventTarget extends EventTarget {
  result: string;
}
interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}

@Component({
  selector: 'app-procedure-comp',
  templateUrl: './procedure-comp.component.html',
  styleUrls: ['./procedure-comp.component.scss'],
  providers: [SrubUpService]
})
export class ProcedureCompComponent implements OnInit {
  catIn: boolean = false;
  selectedPPName: string;
  upppId: any = '';
  pressurepointListchecked: any = [];
  pppressurerequired = 0;
  categoryId: any;
  patientPosPressList: any = [];
  edituserprocedurechecklistimgId: any = [];
  imageTitleList: any = [];
  filename:any;
  imageUrl: any = [];
  checklistForm: FormGroup;
  pressureForm: FormGroup;
  submitted = false;
  public baseurl: string = environment.base_url;
  UserProcedureCheckListID: any;
  imagedisplay = "none";
  public image: any;
  public imageAdd: any = [];
  loginUserId: number;
  display = "none";
  editdisplay = "none";
  videodisplay = "none";
  isImpersonateMode: boolean;
  selectedProcedureName: string;
  editvisi: number;
  showEditingDiv: number;
  iValue: number;
  imageUploadApiUrlLength: number;
  public loading = false;
  checkListIndex: number;
  index: boolean;
  index1: number;
  edit: boolean;
  category: number;
  imagePath: string;
  procedureId: string;
  specialityId: number;
  addImageInvisible: number;
  selectedProcedureId: number;
  editmode = false;
  addChecklistItem: number;
  addpressurepoint: number;
  addVideoVisible: number;
  videoList: Array<VideoDTO>;
  safeVideoList: Array<SafeVideoDTO>;
  imageList: Array<ImageDTO>;
  imageList1: any = [];
  checkList: Array<CheckListDTO>;
  videoUrl: string;
  videoName: string;
  imageName: string;
  imageName1: any;
  description: string;
  uploadUrl: string;
  myHeaders: { [name: string]: any };
  tempUrl: any = [];
  selectedSpecialityImage: string;
  imageToShow: string;
  pressurepointList: any;
  values = [];
  imgflag = 0;
  isPatientPositioning: boolean;
  totalImagesCanShow: number;

  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private router: Router, private _sanitizer: DomSanitizer, private cookieService: CookieService, private appUserDetails: AppWideUser, private token: Token, private scrubUpService: SrubUpService) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.selectedSpecialityImage = './assets/img/card_icons/' + Globals.SpecialityName + '.png';
    //this.selectedProcedureName = Globals.SelectedProcedureName;

    this.isImpersonateMode = JSON.parse(this.cookieService.get('impersonation'));
    if (this.isImpersonateMode == true) {
      this.loginUserId = JSON.parse(this.cookieService.get('userId'));
    }
    else {
      this.loginUserId = this.appUserDetails.UserId;
    }

    this.category = Globals.CategoryId;
    this.procedureId = Globals.PId;
    this.specialityId = Globals.SpecialityId;

    this.imageList = new Array<ImageDTO>();
    this.checkList = new Array<CheckListDTO>();
    this.videoList = new Array<VideoDTO>();
    this.safeVideoList = new Array<SafeVideoDTO>();
    this.checkListIndex = 1;
    this.addImageInvisible = 0;
    this.uploadUrl = this.baseurl + "api/Speciality/UploadImage?userId=" + this.loginUserId;
    this.imageUploadApiUrlLength = (this.baseurl + "api/Speciality/GetUploadedImage?imageName=").length;
    this.myHeaders = {
      'Authorization': 'Bearer ' + this.token.access_token,
      'UserId': this.appUserDetails.UserId,
      'ModulePath': "Procedure"
    };
    this.tempUrl = [];
    this.isPatientPositioning = false;
    const Image = JSON.parse(localStorage.getItem("Image"));
    this.totalImagesCanShow = Image.FeatureValue;
  }

  removevalue(UserProcedureCheckListImageID, i) {
    if (UserProcedureCheckListImageID) {
      let deleteImage = {
        "UserProcedureCheckListID": 0,
        "UserProcedureCheckListImageID": UserProcedureCheckListImageID
      }
      this.scrubUpService.DeleteImages(this.token, deleteImage, this.loginUserId).subscribe(x => {
        if (x.Status == true) {
          this.values.splice(i, 1);
          this.imageUrl.splice(i, 1);
          this.imageAdd.splice(i, 1);
        }
        else if (x.Status == false) {
        }
      });
    }
    else {
      this.values.splice(i, 1);
      this.imageUrl.splice(i, 1);
      this.imageAdd.splice(i, 1);
    }

  }

  addvalue() {
    this.values.push({});
  }
  ShowImage(index, path) {
    this.imageToShow = path;
  }

  GetImage(imageSrc) {
    imageSrc.forEach(element => {
      this.scrubUpService.GetImage(this.token, element, this.appUserDetails.UserId).subscribe(ab => {
        this.imageList.forEach(a => {
          if (a.ImagePath == element) {
            a.ImageBase64 = "data:image/png;base64," + ab
          }
        });
      });

    });
  }
  checkExtension(file: any) {
    let mimeType = ['image/png', 'image/jpeg', 'image/jpg'];
    return mimeType.indexOf(file.type);
  }
  OnUploadFinished($event: any, imagename: any, i: any, userprcimgid) {

    let tempimage: any;
    if (userprcimgid == '0')
      userprcimgid = 0;

    if ($event == "test") {
      tempimage = { 'imageUpdate': false, 'ImageTitle': imagename,'UserProcedureCheckListImageID': userprcimgid };
    }
    else {

     this.image="";
      let uploadStatus: string;
      const files = $event.target.files || $event.srcElement.files;
      const file = files[0];
      const type = this.checkExtension(file);
      if (file && type != -1) {

        this.image = file;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event: any) => {
          this.imageUrl[i] = event.target.result;
        };

      }

      tempimage = { 'imageUpdate': true, 'ImageTitle': imagename, 'ImagePath': this.image, 'UserProcedureCheckListImageID': userprcimgid };
    }
if(this.image !="")
{
  tempimage = { 'imageUpdate': true, 'ImageTitle': imagename, 'ImagePath': this.image, 'UserProcedureCheckListImageID': userprcimgid };
}
    this.imageAdd[i] = tempimage;
    //this.filename="";
   // console.log(this.imageAdd);
  }

  showAddVideo() {
    this.videodisplay = "block";
    this.addVideoVisible = 1;
  }
  cancelAddVideo() {
    this.addVideoVisible = 0;
  }
  newChecklistItem() {
    this.checklistForm.controls.description.setValue('');
    this.display = "block";
    this.addChecklistItem = 1;
    this.showEditingDiv = -1;
    this.editvisi = 0;
    this.description = "";
    this.imageAdd = [];
    this.imageUrl = [];
    this.values = [];
  }


  cancelPressurelist() {
    // const arr = <FormArray>this.pressureForm.controls.pp_pressure;
    // arr.controls = [];
    this.addpressurepoint = 0;
    this.addChecklistItem = 0;
    this.pressureForm.controls.userProcedurePatientPositioningName.setValue('');
    this.pressureForm.controls.pressurePoints.setValue('');
    this.closeModalDialog();
    this.getPressurePoint();

  }
  newPressurePoint() {
    const arr = <FormArray>this.pressureForm.controls.pp_pressure;
    arr.controls = [];
    this.display = "block";
    this.addpressurepoint = 1;
    this.showEditingDiv = -1;
    this.editvisi = 0;
    this.pressureForm.controls.userProcedurePatientPositioningName.setValue('');
    this.pressureForm.controls.pressurePoints.setValue('');
    this.addPPPRessure();
      }
  cancelAddImage() {
    this.imagedisplay = "none";
    this.addImageInvisible = 0;
  }
  cancelAddChecklist() {
    this.display = "none";
    this.addChecklistItem = 0;
  }
  OnCancel() {
    this.display = "none";
    this.editdisplay = "none";
    this.addChecklistItem = 0;
    this.addpressurepoint = 0;
    this.showEditingDiv = -1;
    this.editvisi = 0;
    this.description = "";
  }
  OnCancelPressure() {
    this.display = "none";
    this.editvisi = 0;
    this.showEditingDiv = -1;
    this.addpressurepoint = 0;
    this.pressureForm.controls.userProcedurePatientPositioningName.setValue('');
    this.pressureForm.controls.pressurePoints.setValue('');
    this.closeModalDialog();

    this.getPressurePoint();


  }

  AddPressure() {
    let pList = [];


    let pressurepointlist = this.pressureForm.controls['pressurePoints'].value
    for (var i = 0; i < pressurepointlist.length; i++) {
      pList.push(pressurepointlist[i]);
    }
    let customepressurePoint = this.pressureForm.controls['pp_pressure'].value;

    for (var i = 0; i < customepressurePoint.length; i++) {
      if (customepressurePoint[i]['ppdescription'] != '') {
        let first = customepressurePoint[i]['ppdescription'].substr(0, 1).toUpperCase();
        let test = first + customepressurePoint[i]['ppdescription'].substr(1);

        pList.push(test);
      }

    }
// console.log(pList.length); pList.length == 1
    if (pList.length == 0  ) {
      this.pppressurerequired = 1;
      return;
    }
    else {
      this.pppressurerequired = 0;

    }

    const result = Array.from(pList.reduce((m, t) => m.set(t, t), new Map()).values());

    this.submitted = true;
    if (this.pressureForm.invalid)
      return;

    let data = {
      'userProcedurePatientPositioningID': 0,
      "userProcedurePatientPositioningName": this.pressureForm.controls['userProcedurePatientPositioningName'].value,
      "userProcedureID": this.procedureId,
      "pressurePoints": result
    }
    this.loading = true;
    this.scrubUpService.AddPatientPosition(this.token, data).subscribe(x => {
      console.log(x);
      if (x.Status == true) {
        swal({
          title: 'Patient Positioning Saved Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);

      } else {
        swal({
          title: 'Patient Position Name Already Exist',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      }

      this.loading = false;
      this.closeModalDialog()
      this.GetComponentDetails();
    });

  }


  AddStep() {

    this.submitted = true;
    if (this.checklistForm.invalid)
      return;

    var formData: any = new FormData();
    let checklistTypeId: any = this.category;
    let userProcedureId: any = this.procedureId;

    formData.append('CheckListTypeID', checklistTypeId);
    formData.append('UserProcedureID', userProcedureId);
    formData.append('Description', this.checklistForm.controls['description'].value);
    formData.append('UserProcedureCheckListID', '0');
    let imagelistLength = this.imageAdd.length;

    if (imagelistLength > 0) {
      for (var i = 1; i <= imagelistLength; i++) {
        formData.append("ImageTitle" + i, this.imageAdd[i - 1].ImageTitle);
        if (this.imageAdd[i - 1].imageUpdate == true) {
          formData.append("ImageFile" + i, this.imageAdd[i - 1].ImagePath);
        }


      }
    }
    // else if(imageTitlelistLength>0){
    //   for (var i = 1; i <= imageTitlelistLength; i++) {
    //     formData.append("ImageTitle" + i, this.imageTitleList[i-1]);

    //   }
    // }
    this.loading = true;
    this.scrubUpService.AddCheckList(this.token, formData).subscribe(x => {
      if (x.Status == true) {
        swal({
          title: 'CheckList Saved Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);

      } else {

      }
      //this.OnCancel();
      this.loading = false;
      this.closeModalDialog()
      this.GetComponentDetails();
    });

  }

  closeModalDialog() {
    this.editdisplay = "none";
    this.display = "none";
    this.imagedisplay = "none";
    this.videodisplay = "none";
  }

  SaveCheckList() {

  }

  UpdatePatientPosition() {

    let pList = [];


    let pressurepointlist = this.pressureForm.controls['pressurePoints'].value
    for (var i = 0; i < pressurepointlist.length; i++) {
      pList.push(pressurepointlist[i]);
    }
    let customepressurePoint = this.pressureForm.controls['pp_pressure'].value;

    for (var i = 0; i < customepressurePoint.length; i++) {
      if (customepressurePoint[i]['ppdescription'] != '') {
        let first = customepressurePoint[i]['ppdescription'].substr(0, 1).toUpperCase();
        let test = first + customepressurePoint[i]['ppdescription'].substr(1);
        pList.push(test);
      }

    }
    // console.log(pList.length); pList.length == 1
    if ( pList.length == 0) {
      this.pppressurerequired = 1;
      return;
    }
    else {
      this.pppressurerequired = 0;

    }
    console.log(pList);
    const result = Array.from(pList.reduce((m, t) => m.set(t, t), new Map()).values());
    // console.log(result);
    this.submitted = true;
    if (this.pressureForm.invalid)
      return;
    let data = {
      'userProcedurePatientPositioningID': this.upppId,// take id from hidden
      "userProcedurePatientPositioningName": this.pressureForm.controls['userProcedurePatientPositioningName'].value,
      "userProcedureID": this.procedureId,
      "pressurePoints": result

    }
    this.loading = true;
    this.scrubUpService.AddPatientPosition(this.token, data).subscribe(x => {
      if (x.Status == true) {
        swal({
          title: 'Patient Positioning has been updated successfully.',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      } else {

      }
      this.pressureForm.controls.pressurePoints.setValue('');
      this.loading = false;
      this.closeModalDialog()
      this.GetComponentDetails();
    });

    this.imageUrl = [];

  }


  UpdateChecklist() {
    this.submitted = true;
    if (this.checklistForm.invalid)
      return;

    // console.log(this.imageAdd);
    //console.log(this.imageAdd[0].ImagePath);
    let imagelistLength = this.imageAdd.length;
    let imageTitlelistLength = this.imageTitleList.length;
    //console.log(imagelistLength);

    var formData: any = new FormData();
    let checklistTypeId: any = this.category;
    let userProcedureId: any = this.procedureId;
    // console.log(this.description);
    formData.append('CheckListTypeID', checklistTypeId);
    formData.append('UserProcedureID', userProcedureId);
    formData.append('Description', this.checklistForm.controls['description'].value);
    formData.append('UserProcedureCheckListID', this.UserProcedureCheckListID);
    if (imagelistLength > 0) {
      for (var i = 1; i <= imagelistLength; i++) {

        formData.append("UserProcedureCheckListImageID" + i, this.imageAdd[i - 1].UserProcedureCheckListImageID ? this.imageAdd[i - 1].UserProcedureCheckListImageID : 0)
        formData.append("ImageTitle" + i, this.imageAdd[i - 1].ImageTitle);
        if (this.imageAdd[i - 1].imageUpdate == true)
          formData.append("ImageFile" + i, this.imageAdd[i - 1].ImagePath);
      }
    }
    // else if(imageTitlelistLength>0){
    //   for (var i = 1; i <= imageTitlelistLength; i++) {
    //     formData.append("ImageTitle" + i, this.imageTitleList[i-1]);

    //   }
    // }

    this.loading = true;
    this.scrubUpService.updateCheckList(this.token, formData).subscribe(x => {
      if (x.Status == true) {
        swal({
          title: 'CheckList Updated Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      } else {

      }

      this.loading = false;
      this.closeModalDialog()
      this.GetComponentDetails();
    });

    this.imageUrl = [];

  }

  editPressurePoint(index: number, UserProcedurePatientPositioningID: any) {
    this.pressureForm.controls.pressurePoints.setValue('');
    const arr = <FormArray>this.pressureForm.controls.pp_pressure;
    arr.controls = [];

    this.upppId = UserProcedurePatientPositioningID;
    this.index1 = index;
    this.editmode = true;
    this.display = "block";
    this.editdisplay = "block";
    this.addChecklistItem = 1;
    this.addpressurepoint = 0;

    this.editvisi = 1;
    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
      }
      else {
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.iValue = index;
      }

      this.edit = false;
    }
    else {
      this.showEditingDiv = index;
      this.iValue = index;
      this.edit = false;
    }
    this.getPressurePoint();
    this.scrubUpService.editGgetPatientPosition(this.token, UserProcedurePatientPositioningID).subscribe(x => {

      if (x.Status == true && x['Data'] != null) {
        let datatest = x['Data'];

        this.form.userProcedurePatientPositioningName.setValue(x['Data']['UserProcedurePatientPositioningName']);
        let ppdescriptionArray = [];

        for (let i = 0; i <= x['Data']['PressurePoints'].length; i++) {
          if (i == 0) {
            ppdescriptionArray.push({ 'ppdescription': '' });
          }
          ppdescriptionArray.push({ 'ppdescription': x['Data']['PressurePoints'][i] });
        }

        for (let i = 0; i <= x['Data']['PressurePoints'].length; i++) {

          this.pp_pressure.push(this.newPPPressure());
          this.pp_pressure.patchValue(ppdescriptionArray);
        }
      }
      this.loading = false;
    });


  }

  editChecklistItem(index: number, stepContent: any, UserProcedureCheckListID: any) {
    this.imageUrl = [];
    this.imageAdd = [];
    this.edituserprocedurechecklistimgId = [];

    this.checklistForm.controls.description.setValue('');
    this.description = "";
    this.index1 = index;
    this.editmode = true;
    this.display = "block";
    this.editdisplay = "block";
    this.addChecklistItem = 1;
    this.addChecklistItem = 0;
    this.editvisi = 1;
    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
      }
      else {
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.iValue = index;
      }
      // this.description = stepContent;
      this.checklistForm.controls.description.setValue(stepContent);
      this.edit = false;
    }
    else {
      this.checklistForm.controls.description.setValue(stepContent);
      // this.description = stepContent;
      this.showEditingDiv = index;
      this.iValue = index;
      this.edit = false;
    }

    //UserProcedureCheckListID= '2653';
    this.UserProcedureCheckListID = UserProcedureCheckListID;
    this.scrubUpService.editGetuserProcedurechecklist(this.token, UserProcedureCheckListID).subscribe(x => {
      if (x['Data'] != null && x.Status == true) {
        this.values = x['Data'];
        let lengthimage = x['Data'].length;
        for (var i = 0; i < lengthimage; i++) {
          this.imageUrl[i] = x['Data'][i].ImagePath;
          this.edituserprocedurechecklistimgId[i] = x['Data'][i].UserProcedureCheckListImageID;
          this.imageAdd.push({ "imageUpdate": false, 'ImageTitle': x['Data'][i].ImageTitle, 'ImagePath': x['Data'][i].ImagePath, 'UserProcedureCheckListImageID': x['Data'][i].UserProcedureCheckListImageID });
        }

      }
      this.loading = false;
    });
    //console.log( this.imageUrl);

  }

  DeleteImage(UserProcedureCheckListImageID) {
    let deleteImage = {
      "UserProcedureCheckListID": 0,
      "UserProcedureCheckListImageID": UserProcedureCheckListImageID
    }

    this.scrubUpService.DeleteImages(this.token, deleteImage, this.loginUserId).subscribe(x => {
      if (x.Status == true) {
        this.GetComponentDetails();
        swal({
          title: 'Images deleted Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      } else if (x.Status == false) {
        swal({
          title: 'Deletion Failed!!',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      }

    });

  }

  DeletePatientPosition(UserProcedurePatientPositioningID) {
    swal({
      title: 'Are you sure you want to Delete this Patient Position?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Confirm',
      buttonsStyling: false,
      allowOutsideClick: false
    }).then(() => {
      this.loading = true;
      let deletepatientposition = {
        "Id": UserProcedurePatientPositioningID
      }

      this.scrubUpService.DeletePatientPosition(this.token, deletepatientposition).subscribe(x => {
        if (x.Status == true) {
          swal({
            title: 'Patient Position has been deleted Successfully',
            type: "success",
            timer: 2000,
            showConfirmButton: false
          }).catch(swal.noop);
        } else if (x.Status == false) {
          swal({
            title: 'Deletion Failed!!',
            type: "info",
            timer: 2000,
            showConfirmButton: false
          }).catch(swal.noop);
        }
        this.GetComponentDetails();
        this.OnCancel();
      });
      this.loading = false;
    });

  }


  DeleteCheckList(UserProcedureID) {
    swal({
      title: 'Are you sure you want to Delete this Checklist?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Confirm',
      buttonsStyling: false,
      allowOutsideClick: false
    }).then(() => {
      this.loading = true;
      let deletechecklist = {
        "UserProcedureCheckListID": UserProcedureID,
        "UserProcedureCheckListImageID": 0
      }

      this.scrubUpService.DeleteCheckList(this.token, deletechecklist).subscribe(x => {
        if (x.Status == true) {
          swal({
            title: 'CheckList deleted Successfully',
            type: "success",
            timer: 2000,
            showConfirmButton: false
          }).catch(swal.noop);


        } else if (x.Status == false) {
          swal({
            title: 'Deletion Failed!!',
            type: "info",
            timer: 2000,
            showConfirmButton: false
          }).catch(swal.noop);

        }

       this.GetComponentDetails();
       this.OnCancel();
      });

      this.loading = false;
    });

  }



  GetComponentDetails() {
    this.loading = true;
    this.imageList1 = [];
    this.tempUrl = [];
    this.checkList=[];
    this.patientPosPressList=[];
    if (this.loginUserId == 1) {
      this.scrubUpService.getuserProcedurechecklist(this.token, this.category, this.procedureId).subscribe(x => {
        if (x['Data'] != null && x.Status == true) {
          this.checkList = x['Data'];
          //console.log(this.checkList);
          let checklistLength = x['Data'].length;
          for (var i = 0; i < checklistLength; i++) {
            // console.log(this.checkList[i]['StepNo']);
            let imageListlength = 0;
            imageListlength = x['Data'][i]['CheckListsImages'].length;
            for (var j = 0; j < imageListlength; j++) {
              //this.tempUrl[j]['images']=this.checkList[i]['CheckListsImages'][j];
              //  console.log(this.checkList[i]['CheckListsImages'][j]);
              this.tempUrl.push({ 'ImagePath': this.checkList[i]['CheckListsImages'][j]['ImagePath'], 'ImageTitle': this.checkList[i]['CheckListsImages'][j]['ImageTitle'], 'UserProcedureCheckListImageID': this.checkList[i]['CheckListsImages'][j]['UserProcedureCheckListImageID'], 'StepNo': this.checkList[i]['StepNo'] });
              // console.log( this.tempUrl);
              //this.tempUrl.push(this.checkList[i]['CheckListsImages'][j]);
            }
          }
          this.imageList1 = this.tempUrl;
        }
        this.loading = false;
      });

      this.scrubUpService.GetPatientPositioningsById(this.token, this.procedureId).subscribe(x => {
        if (x['Data'] != null && x['Status'] == true) {
          this.patientPosPressList = x['Data'];

          // console.log(this.patientPosPressList);
        }
        // console.log(this.patientPosPressList.length);
        this.loading = false;
      });

      //console.log(this.imageList1);
    }
    else {
      let packageTypesFeatures = JSON.parse(
        this.cookieService.get("PackageTypesFeatures")
      );

      const isPackageDowngraded = packageTypesFeatures.IsPackageDowngraded
        ? packageTypesFeatures.IsPackageDowngraded
        : false;

      const step = JSON.parse(localStorage.getItem("Step"));
      const stepFeatureValue = (step && step.FeatureValue) ? step.FeatureValue : 0;
      this.scrubUpService
        .getuserProcedurechecklistItem(
          this.token,
          this.category,
          this.procedureId,
          stepFeatureValue,
          isPackageDowngraded
        )
        .subscribe((x) => {
          if (x["Data"] != null && x.Status == true) {
            this.checkList = x["Data"];
            //console.log(this.checkList);
            let checklistLength = x["Data"].length;
            for (var i = 0; i < checklistLength; i++) {
              // console.log(this.checkList[i]['StepNo']);
              let imageListlength = 0;
              imageListlength = x["Data"][i]["CheckListsImages"].length;
              for (var j = 0; j < imageListlength; j++) {
                this.tempUrl.push({
                  ImagePath:
                    this.checkList[i]["CheckListsImages"][j]["ImagePath"],
                  ImageTitle:
                    this.checkList[i]["CheckListsImages"][j]["ImageTitle"],
                  UserProcedureCheckListImageID:
                    this.checkList[i]["CheckListsImages"][j][
                      "UserProcedureCheckListImageID"
                    ],
                  StepNo: this.checkList[i]["StepNo"],
                });
              }
            }
            this.imageList1 = this.tempUrl;
          }
          this.loading = false;
        });

      this.patientPosPressList = [];

      const patientosition = JSON.parse(localStorage.getItem("patientosition"));

      const patientositionFeatureValue = (patientosition && patientosition.FeatureValue) ? patientosition.FeatureValue : 0;

      this.isPatientPositioning = patientositionFeatureValue == 1;
    this.scrubUpService
      .GetPatientPositioningsById_app(
        this.token,
        this.procedureId,
        patientositionFeatureValue,
        isPackageDowngraded
      )
      .subscribe((x) => {
        if (x["Data"] != null && x["Status"] == true) {
          this.patientPosPressList = x["Data"];
          //console.log(this.patientPosPressList);
        }
        // console.log(this.patientPosPressList.length);
        this.loading = false;
      });
  }

  }

  GoBack() {
    let compNmae: string;
    compNmae = this.route.routeConfig.component.name;

    this.router.navigateByUrl('layout', { skipLocationChange: true }).then(() =>
      this.router.navigate(["layout/procedure"]));

  }

  UserClick(btnCount) {

    this.index = false;
    this.edit = false;
    if (btnCount == 0) {

      this.index = true;
      this.edit = false;
    }
    if (btnCount == 1) {
      this.index = true;
      this.edit = false;
      this.selectedProcedureId = 0;

    }
    if (btnCount == 2) {
      this.edit = true;
      this.index = false;
    }
    if (btnCount == 3) {
      this.imagedisplay = "block";
      if (this.imageList.length == 5) {
        swal({
          title: 'Images limit reached ',

          showConfirmButton: true
        }).catch(swal.noop);
      }
      else {
        this.edit = true;
        this.addImageInvisible = 1;
      }
    }

  }
  checklistFormvalidation() {
    this.checklistForm = this.formBuilder.group({
      description: ['', Validators.required]
    });
  }
  get f() { return this.checklistForm.controls; }

  checkpressureformValidation() {
    this.pressureForm = this.formBuilder.group({
      userProcedurePatientPositioningName: ['', Validators.required],
      pressurePoints: [''],
      pp_pressure: this.formBuilder.array([this.newPPPressure()]),
    });

  }
  get form() { return this.pressureForm.controls; }

  newPPPressure(): FormGroup {
    return this.formBuilder.group({
      ppdescription: '',

    })
  }
  get pp_pressure(): FormArray {
    return this.pressureForm.get('pp_pressure') as FormArray
  }
  //   getPPPressure(i:any,controlname:any) {
  //     let control =( (<FormArray>this.pressureForm.get('pp_pressure')).controls[i].get(controlname));
  //     return ((!control?.valid && control?.touched) || (control?.untouched && this.submitted));
  // }

  addPPPRessure() {
    this.pp_pressure.push(this.newPPPressure())
  }
  removePPPRessure(i: number) {
    this.pp_pressure.removeAt(i)
  }
  ngOnInit() {
    this.categoryId = Globals.CategoryId;
    this.getPressurePoint();
    this.checklistFormvalidation();
    this.checkpressureformValidation();

    $('.wizard-card').bootstrapWizard({
    });

    // Prepare the preview for profile picture
    $('#wizard-picture').change(function () {
      const input = $(this);

      if (input[0].files && input[0].files[0]) {
        const reader: any = new FileReader();

        reader.onload = function (e: FileReaderEvent) {
          $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
        };
        reader.readAsDataURL(input[0].files[0]);
      }
    });

    $('[data-toggle="wizard-checkbox"]').click(function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).find('[type="checkbox"]').removeAttr('checked');
      } else {
        $(this).addClass('active');
        $(this).find('[type="checkbox"]').attr('checked', 'true');
      }
    });

    $('.set-full-height').css('height', 'auto');

    this.GetComponentDetails();

  }

  getPressurePoint() {
    this.pressurepointList = [];

    this.loading = true;
    this.scrubUpService.GetPressurePoint(this.token).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true) {
        this.pressurepointList = x['Data'];
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  ngOnChanges(changes: SimpleChanges) {
    const input = $(this);

    if (input[0].files && input[0].files[0]) {
      const reader: any = new FileReader();

      reader.onload = function (e: FileReaderEvent) {
        $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
      };
      reader.readAsDataURL(input[0].files[0]);
    }
  }

  ngAfterViewInit() {
    $('.wizard-card').each(function () {

      const $wizard = $(this);
      const index = $wizard.bootstrapWizard('currentIndex');
      let $total = $wizard.find('.nav li').length;
      let $li_width = 100 / $total;

      let total_steps = $wizard.find('.nav li').length;
      let move_distance = $wizard.width() / total_steps;
      let index_temp = index;
      let vertical_level = 0;

      let mobile_device = $(document).width() < 600 && $total > 3;

      if (mobile_device) {
        move_distance = $wizard.width() / 2;
        index_temp = index % 2;
        $li_width = 50;
      }

      $wizard.find('.nav li').css('width', $li_width + '%');

      let step_width = move_distance;
      move_distance = move_distance * index_temp;

      let $current = index + 1;

      if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
        move_distance -= 8;
      } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
        move_distance += 8;
      }

      if (mobile_device) {
        let x: any = index / 2;
        vertical_level = parseInt(x);
        vertical_level = vertical_level * 38;
      }

      $wizard.find('.moving-tab').css('width', step_width);
      $('.moving-tab').css({
        'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
        'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

      });

      $('.moving-tab').css({
        'transition': 'transform 0s'
      });
    });
  }
  onclick() {

  }


}
function isset(UserProcedureCheckListImageID: any) {
  throw new Error('Function not implemented.');
}




// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/procedure-comp/procedure-comp.component.ts